query GetEmployee($id: ID!, $withUser: Boolean = false) {
  employee(id: $id) {
    id
    name
    salesforceId
    title
    welcomeCallLink
    profileName
    email
    worksAtFp
    leftOn
    offboardedAt
    startDate
    trainingRequired
    createdAt
    salesforceLicenceActive
    signInStatus
    team {
      id
      name
    }
    roles {
      id
      name
    }
    user @include(if: $withUser) {
      id
    }
  }
}
